import { createGlobalStyle } from 'styled-components'
import Quicksand from '../assets/fonts/Quicksand/Quicksand-VariableFont_wght.ttf'
import Nunito from '../assets/fonts/Nunito/Nunito-VariableFont_wght.ttf'
import colors from './colors'

const GlobalStyle = createGlobalStyle`
* {
    @font-face {
        font-family: 'Quicksand';
        src: url(${Quicksand}) format('truetype');
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: 'Nunito';
        src: url(${Nunito}) format('truetype');
        font-weight: 200 800;
        font-style: normal;
    }

margin: 0;
padding: 0;
box-sizing: border-box;
font-family: 'Nunito', 'Trebuchet MS', Helvetica, sans-serif;
}

html, body {
width: 100%;
height: 100%;
color: ${colors.forth};
overflow-y: auto;
}

#root {
width: 100%;
height: 100%;
}
`
export default GlobalStyle
